import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { setFilterKeyword, setFilterTags } from 'src/context/reducers/filter-settings/filterSlice';
import { ClusterModule, clusterModuleForPath } from './config';

/**
 * Cluster module of the current page. Clears the header's cluster and keyword selections
 * when the module changes: Brand and Non Brand have separate cluster lists and search
 * terms, so values picked on one side would filter the other side's grid down to nothing.
 */
export function useResetModuleFilters(pathname: string): ClusterModule {
  const dispatch = useDispatch();
  const clusterModule = clusterModuleForPath(pathname);
  const previous = useRef(clusterModule);

  useEffect(() => {
    if (previous.current === clusterModule) return;
    previous.current = clusterModule;
    dispatch(setFilterTags([]));
    dispatch(setFilterKeyword([]));
  }, [clusterModule, dispatch]);

  return clusterModule;
}
